import React, { useState, useEffect } from "react";
import "datatables.net-dt/css/dataTables.dataTables.css";
import "datatables.net";
import { useGlobalContext } from '../GlobalContext';

const EntriJurnal = () => {
  const { api, periodeakun } = useGlobalContext();
  const [entries, setEntries] = useState([]);
  const [entry, setEntry] = useState({ kdperk: "", perkiraan: "", debet: "0", kredit: "0" });

  const [tanggal, setTanggal] = useState("");
  const [noJurnal, setNoJurnal] = useState("");
  const [uraian, setUraian] = useState("");
  const [daftarPerkiraan, setDaftarPerkiraan] = useState([]);

  const generateNoJurnal = async () => {
    try {
      const kode = "JU";
      const tahun = periodeakun.toString().substring(0, 4);
      const bulan = periodeakun.toString().substring(4, 6);
      const periodeBaru = `${bulan}.${tahun.slice(-2)}`;
      const response = await api.get(`/api/akuntansi/getnourutjurnal/${kode}/${periodeBaru}`);
      setNoJurnal(response.data.jnobukti);
    } catch (error) {
      console.error("Error generating journal number:", error);
      alert("Gagal membuat nomor jurnal");
    }
  };

  useEffect(() => {
    const today = new Date().toISOString().substr(0, 10);
    setTanggal(today);
    
    const getPerkiraan = async () => {
      try {
        const response = await api.get("/api/akuntansi");
        if (Array.isArray(response.data)) {
          setDaftarPerkiraan(response.data);
        } else {
          alert("Data perkiraan tidak tersedia.");
        }
      } catch (error) {
        console.error('Error fetching data perkiraan:', error);
        alert("Gagal mengambil data perkiraan.");
      }
    };
    
    getPerkiraan();
  }, [api]);

  const formatNumber = (value) => {
    if (!value) return "0";
    const number = parseFloat(value.toString().replace(/\./g, "")
      .replace(",", "."));    
    if (isNaN(number)) return "0";
      return new Intl.NumberFormat("id-ID", {
      maximumFractionDigits: 2,
      }).format(number);
  };

  const formatNumber2 = (value) => {
    if (!value) return "0";
    const number = Number(value); 
    if (isNaN(number)) return "0";
      return new Intl.NumberFormat("id-ID", {
      maximumFractionDigits: 2,
    }).format(number);
  };

  const parseNumber = (value) => {
    if (!value) return "0";
    const number = parseFloat(
      value.toString()
      .replace(/\./g, "")
      .replace(",", "."));    
    return isNaN(number) ? 0 : number
    /* (isNaN(number)) return "0";
      return new Intl.NumberFormat("id-ID", {
      maximumFractionDigits: 2,
    }).format(number);*/
  };

  /*const handleKodeBlur = async () => {
    if (!entry.kdperk) return;

    try {
      const response = await api.get(`/api/akuntansi/${entry.kdperk}`);
      const data = response.data;
      if (data && data.keterangan) {
        setEntry((prev) => ({
          ...prev,
          perkiraan: data.keterangan?.trim() || "",
        }));
      } else {
        alert("Kode perkiraan tidak ditemukan.");
        setEntry((prev) => ({
          ...prev,
          perkiraan: "",
        }));
      }
    } catch (error) {
      console.error("Error fetching account data:", error);
      alert("Kode perkiraan tidak ditemukan.");
      setEntry((prev) => ({
        ...prev,
        perkiraan: "",
      }));
    }
  };*/

  const handleNumberBlur = (name) => {
    setEntry((prev) => ({
    ...prev,
    [name]: formatNumber(prev[name]),
    }));
  };  

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "debet" || name === "kredit") {
      const cleaned = value.replace(/[^0-9.,]/g, "");
      setEntry((prev) => ({ 
        ...prev,
        [name] :cleaned,
        [name === "debet" ? "kredit" : "debet"]: "0",
      }));    
    } else if (name === "kdperk") {
      // Cari perkiraan dari daftarPerkiraan berdasarkan kode yang dipilih
      const selectedPerkiraan = daftarPerkiraan.find(item => item.kdperk === value);
      setEntry((prev) => ({
        ...prev,
        kdperk: value,
        perkiraan: selectedPerkiraan ? selectedPerkiraan.keterangan : "",
      }));
    } else {
      setEntry((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const addEntry = () => {
    if (!entry.kdperk || !entry.perkiraan || (parseNumber(entry.debet) === 0 && parseNumber(entry.kredit) === 0)) {
      alert("Mohon lengkapi kode, perkiraan, dan nominal.");
      return;
    }

    setEntries(prevEntries => [...prevEntries, {
      kdperk: entry.kdperk,
      perkiraan: entry.perkiraan,
      debet: entry.debet,
      kredit: entry.kredit
    }]);

    setEntry({ kdperk: "", perkiraan: "", debet: "0", kredit: "0" });
  };

  const deleteEntry = (index) => {
    setEntries(prevEntries => prevEntries.filter((_, i) => i !== index));
  };

  const calculateTotals = () => {
    let totalDebit = 0;
    let totalKredit = 0;

    entries.forEach((item) => {
      totalDebit += parseNumber(item.debet);
      totalKredit += parseNumber(item.kredit);      
    });

    return { totalDebit, totalKredit };
  };

  const handleSubmit = async () => {
    const { totalDebit, totalKredit } = calculateTotals();

    if (!tanggal || !noJurnal || !uraian || entries.length === 0) {
      alert("Mohon lengkapi semua data dan pastikan ada entri.");
      return;
    }

    // New validation for the date
    const selectedDate = new Date(tanggal);
    const selectedMonth = selectedDate.getMonth() + 1; // getMonth() is 0-indexed
    const selectedYear = selectedDate.getFullYear();
    const periodeYear = parseInt(periodeakun.toString().substring(0, 4));
    const periodeMonth = parseInt(periodeakun.toString().substring(4, 6));

    if (selectedYear !== periodeYear || selectedMonth !== periodeMonth) {
      alert("Tanggal tidak berada dalam periode akuntansi yang aktif (" + periodeYear + "-" + (periodeMonth < 10 ? '0' + periodeMonth : periodeMonth) + ").");
      return;
    }

    console.log(totalDebit.toString());
    console.log(totalKredit.toString());

    if (totalDebit !== totalKredit) {
      alert("Total debit dan kredit tidak seimbang. Mohon periksa kembali.");
      return;
    }

    const details = entries.map((item, index) => ({
      jnobukti: noJurnal,
      kdperk: item.kdperk,
      uraianperk: item.perkiraan,
      debet: parseNumber(item.debet),
      kredit: parseNumber(item.kredit),
      urut: index + 1
    }));

    try {
      await api.post("/api/akuntansi/jurnal", {
        jnobukti: noJurnal,
        jtanggal: tanggal,
        uraian1: uraian,
        details
      });

      alert("Data jurnal berhasil disimpan!");
      setTanggal(new Date().toISOString().substr(0, 10));
      setNoJurnal("");
      setUraian("");
      setEntries([]);
      setEntry({ kdperk: "", perkiraan: "", debet: "0", kredit: "0" });
    } catch (error) {
      console.error("Failed to save journal:", error);
      alert("Terjadi kesalahan saat menyimpan jurnal.");
    }
  };

  const tdStyle = {
    padding: "4px",
    lineHeight: "1.2",
    verticalAlign: "middle"
  };

  const { totalDebit, totalKredit } = calculateTotals();

  return (
    <div className="container-fluid py-4">
      <div className="row justify-content-center">
        <div className="col-12">
          <div className="card card-info">
            <div className="card-header">
              <div className="d-flex justify-content-between align-items-center w-100">
                <h3 className="card-title">Entri Jurnal</h3>
              </div>
            </div>
            <div className="card-body">
              <div className="row mb-1">
                <div className="col-md-2">
                  <label htmlFor="tanggal" className="col-form-label">Tanggal</label>
                </div>
                <div className="col-md-3">
                  <input id="tanggal" type="date" value={tanggal} onChange={(e) => setTanggal(e.target.value)} className="form-control-sm" style={{ maxWidth: "150px" }}/>
                </div>
              </div>
              <div className="row mb-1 align-items-center">
                <div className="col-md-2">
                  <label htmlFor="nojurnal" className="col-form-label">No Jurnal</label>
                </div>
                <div className="col-md-2 d-flex align-items-center" style={{ gap: "10px" }}>
                  <input id="nojurnal" type="text" value={noJurnal} className="form-control-sm" disabled style={{ maxWidth: "150px" }} />
                  <button className="btn btn-sm btn-primary" onClick={generateNoJurnal}>Click</button>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-2">
                  <label htmlFor="uraian" className="col-form-label">Uraian</label>
                </div>
                <div className="col-md-5">
                  <textarea id="uraian" rows={3} value={uraian} onChange={(e) => setUraian(e.target.value)} className="form-control form-control-sm" ></textarea>
                </div>
              </div>

              <div className="card mt-3">
                <div className="card-body border-top" style={{ overflow: "visible" }}>                  
                  <div className="row mb-1 gx-2 align-items-end border-top" style={{ position: "relative", zIndex: 10 }}>
                    <div className="col-md-5" style={{ position: "relative", zIndex: 100 }}>
                      <label className="form-label"><b>Perkiraan</b></label>
                      <select
                        name="kdperk"
                        value={entry.kdperk}
                        onChange={handleChange}
                        className="form-control form-control-sm"
                        style={{ position: "relative" }}
                      >
                        <option value="">--pilih--</option>
                        {daftarPerkiraan.map((option) => (
                          <option key={option.kdperk} value={option.kdperk}>
                            {option.kdperk + ' - ' + option.keterangan}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label"><b>Debit</b></label>
                      <input
                        type="text"
                        name="debet"
                        value={entry.debet}
                        onChange={handleChange}
                        onBlur={() => handleNumberBlur("debet")}
                        className="form-control form-control-sm text-end"
                        style={{ textAlign: "right" }}
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label"><b>Kredit</b></label>
                      <input
                        type="text"
                        name="kredit"
                        value={entry.kredit}
                        onChange={handleChange}
                        onBlur={() => handleNumberBlur("kredit")}
                        className="form-control form-control-sm text-end"
                        style={{ textAlign: "right" }}
                      />
                    </div>
                    <div className="col-auto ms-auto d-flex align-items-center">
                      <button type="button" className="btn btn-sm btn-primary" onClick={addEntry}>
                        Tambah Data
                      </button>
                    </div>
                  </div>

                  <div className="table-responsive mt-3">
                    <table className="table table-bordered table-hover">
                      <thead>
                        <tr>
                          <th style={{ width: "5%" }}>Pilih</th>
                          <th style={{ width: "10%" }}>Kode</th>
                          <th style={{ width: "45%" }}>Perkiraan</th>
                          <th style={{ width: "15%" }}>Debit</th>
                          <th style={{ width: "15%" }}>Kredit</th>
                          <th style={{ width: "10%", textAlign: "center" }}>Aksi</th>
                        </tr>
                      </thead>
                      <tbody>
                        {entries.map((item, index) => (
                          <tr key={`${item.kdperk}-${index}`}>
                            <td style={tdStyle} className="text-center form-control-sm" >
                              <input type="checkbox" onChange={() => { /* multi-selection logic if needed */ }} />
                            </td>
                            <td style={tdStyle} className="form-control-sm">{item.kdperk}</td>
                            <td style={tdStyle} className="form-control-sm">{item.perkiraan}</td>
                            <td style={tdStyle} className="text-right form-control-sm">{item.debet}</td>
                            <td style={tdStyle} className="text-right form-control-sm">{item.kredit}</td>
                            <td style={tdStyle} className="text-center form-control-sm">
                              <button type="button" className="btn btn-danger btn-sm" onClick={() => deleteEntry(index)}>
                                Hapus
                              </button>
                            </td>
                          </tr>
                        ))}
                        <tr className="fw-bold bg-light">
                          <td style={tdStyle} colSpan="3" className="text-center">Total</td>
                          <td style={tdStyle} className="text-right form-control-sm">{formatNumber2(totalDebit)}</td>
                          <td style={tdStyle} className="text-right form-control-sm">{formatNumber2(totalKredit)}</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="d-flex justify-content-end mt-1">
                    <button className="btn btn-sm btn-primary" type="button" onClick={handleSubmit}>
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EntriJurnal;
